import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SeriesInfo extends Component {
    render() {

        const { webinar } = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <h4 className="h4 text-center brand-color">Webinar Description</h4>
                        <p className="p-tag">{ webinar.description }</p>

                    </div>
                </div>
            </div>
        );
    };
}

SeriesInfo.propTypes = {
    webinar: PropTypes.object.isRequired
};

export default SeriesInfo;



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/SeriesInfo.js